import api from "@/utils/api"; // 共通 Axios（毎回 silent でトークン付与）
import axios from "axios"; // SAS 直ダウンロード用に素の axios も使う

/*
  Blob ストレージからファイルをダウンロードする
  @param {string} fileLink - 画面に表示している Blob のリンク（例: https://.../<container>/<dir>/<timestamp>/<filename>）
 */
export const downloadFile = async (fileLink) => {
	try {
		// 1) fileLink から blob_name（コンテナ名より後ろ）を抽出
		const fileUrl = new URL(fileLink);
		const blob_name = fileUrl.pathname.split("/").slice(2).join("/"); // 先頭2セグメント（/container/...）を除いたパス

		// 2) サーバー API から「SAS 付きダウンロード URL」を取得（毎回 silent でトークン付与は api 側に任せる）
		const { data } = await api.get("", {
			params: {
				action: "GetDownloadBlobURL",
				blob_name,
			},
		});
		const downloadUrl = data?.download_url;
		if (!downloadUrl) throw new Error("Download URL is not available");

		// 3) SAS 付き URL に対して BLOB を取得（SAS は既に URL に含まれているため Authorization は不要）
		const downloadResponse = await axios.get(downloadUrl, {
			responseType: "blob",
			timeout: 30000,
		});

		// 4) ファイル名の決定（Content-Disposition > fileLink の末尾）
		let filename = fileLink.split("/").pop() || "download.bin";
		const dispo = downloadResponse.headers?.["content-disposition"];
		if (dispo && /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/.test(dispo)) {
			const m = dispo.match(/filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/);
			filename = decodeURIComponent(m[1] || m[2] || filename);
		}

		// 5) Blob をオブジェクト URL にしてダウンロード
		const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
		const a = document.createElement("a");
		a.href = url;
		a.setAttribute("download", filename);
		a.style.display = "none";
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
	} catch (error) {
		// ネットワークや CORS、SAS 期限切れなどの詳細をログに残す
		console.error("Error downloading file:", {
			message: error?.message,
			code: error?.code,
			config: error?.config,
			request: error?.request,
			response: error?.response,
		});
		throw new Error("ファイルのダウンロードに失敗しました: " + (error?.message || ""));
	}
};
